import { useEffect } from "react";

const LABORATORIO_URL = "https://cloudlablace.com.ar/#/login";
const PORTAL_HOME_PATH = "/portal/Inicio";

export default function Laboratorio() {
  useEffect(() => {
    window.open(LABORATORIO_URL, "_blank", "noopener,noreferrer");
    window.location.replace(PORTAL_HOME_PATH);
  }, []);

  return null;
}
